import PropTypes from "prop-types";
import sanitizeHtml from "sanitize-html";

const SafeHTML = ({ html }) => {
    return (
        <div
            dangerouslySetInnerHTML={{
                __html: sanitizeHtml(html),
            }}
        />
    );
};

SafeHTML.propTypes = {
    html: PropTypes.string,
};

SafeHTML.defaultProps = {
    html: "",
};

export default SafeHTML;
